import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { License } from './license.model';
import { LicenseService } from './license.service';

@Component({
    selector: 're-primary-acknowledgements',
    templateUrl: './primary-acknowledgements.component.html',
    styleUrls: ['./primary-acknowledgements.component.scss'],
    standalone: false
})
export class PrimaryAcknowledgementsComponent implements OnInit {

  licenses: License[] = [];
  year: number;
  loading: boolean;
  closeResult: string;
  licenseChangesText: string;
  licenseNoticeText: string;
  licenseText: string;
  licenseLink: string;
  popupData: License;

  constructor(private _licenseService: LicenseService, private modalService: NgbModal) {
      this.loading = true;
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
    this.getLicenses();
  }

  /**
   * Get all licenses.
   */
  getLicenses(): void {
      this._licenseService
          .getLicenses()
          .subscribe(
          res => {
              Array.prototype.push.apply(this.licenses, res);
              this.loading = false;
          },
          error => {
          });
  }

  open(content, license: License) {
      this.popupData = license;
      const options: NgbModalOptions = {
          size: 'lg'
      };
      this.modalService.open(content, options).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }
}
